// 账号中心
export default {
  path: '/account',
  component: () => import('@/layout/Empty.vue'),
  children: [
    {
      path: '',
      component: () => import('@/views/user/account/AccountList.vue'),
      redirect: 'information',
      children: [
        {
          path: 'information',
          component: () => import('@/views/user/account/information/Information.vue')
        },
        {
          path: 'self-signature',
          component: () => import('@/views/user/account/signature/SelfSignature.vue')
        },
        {
          path: 'contact',
          component: () => import('@/components/contactSelect/ContactSelectMain.vue'),
          props: { selectable: false }
        },
        {
          path: 'setting',
          component: () => import('@/layout/Empty'),
          redirect: 'setting/notices',
          children: [
            {
              path: 'notices',
              component: () => import('@/views/admin/setting/CommonSetting.vue')
            }
          ]
        },
        {
          path: 'fee',
          component: () => import('@/views/user/fee/FeeMain'),
          redirect: 'fee/myAccount',
          children: [
            {
              path: 'myAccount',
              component: () => import('@/views/user/fee/Fee')
            },
            {
              path: 'OrderAnnal',
              component: () => import('@/views/user/fee/OrderAnnal')
            }
          ]
        }
      ]
    },
    {
      path: 'update-email',
      component: () => import('@/views/user/account/information/updateEmail/UpdateEmailIndex.vue'),
      redirect: 'update-email/first',
      meta: {
        layout: {
          pageBack: true
        },
        personVerify: true
      },
      children: [
        {
          path: 'first',
          component: () => import('@/views/user/account/information/updateEmail/UpdateEmailFirst.vue')
        },
        {
          path: 'second',
          component: () => import('@/views/user/account/information/updateEmail/UpdateEmailSecond.vue')
        },
        {
          path: 'third',
          component: () => import('@/views/user/account/information/updateEmail/UpdateEmailThird.vue')
        }
      ]
    },
    {
      path: 'bind-email',
      component: () => import('@/views/user/account/information/bindEmail/BindEmailIndex.vue'),
      meta: {
        layout: {
          pageBack: true
        },
        personVerify: true
      },
      redirect: 'bind-email/first',
      children: [
        {
          path: 'first',
          component: () => import('@/views/user/account/information/bindEmail/BindEmailFirst.vue')
        },
        {
          path: 'second',
          component: () => import('@/views/user/account/information/bindEmail/BindEmailSecond.vue')
        }
      ]
    },
    {
      path: 'update-password/first',
      component: () => import('@/views/user/account/information/password/UpdatePasswordFirst.vue'),
      meta: {
        layout: {
          pageBack: true
        },
        personVerify: true
      }
    },
    {
      path: 'ca',
      component: () => import('@/views/admin/company/Ca.vue')
    }
  ]
}
